// Base URL (MUST end in '/') under which pdfjs-dist v5's wasm image decoders are
// served. v5 fetches `${wasmUrl}jbig2.wasm` / `${wasmUrl}openjpeg.wasm` (JBIG2 +
// JPEG2000 — both common in SCANNED PDFs) at decode time; if unset, rendering a
// scanned page throws (getFactoryUrlProp requires a trailing-slash string).
//
// Files are synced from node_modules into public/pdfjs-wasm/ by
// scripts/sync-pdfjs-wasm.mjs (prebuild). Pass this to getDocument() ONLY on the
// render paths (PdfReader, PeekPopover, cover) — text-only reads don't decode
// images and need nothing. Respects Vite's configured base.
export const PDFJS_WASM_URL = `${import.meta.env.BASE_URL}pdfjs-wasm/`;
